import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon-checked-circle-green",
  "use": "icon-icon-checked-circle-green-usage",
  "viewBox": "0 0 15.4 15.4",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15.4 15.4\" id=\"icon-icon-checked-circle-green\"><defs><style>#icon-icon-checked-circle-green .cls-1,#icon-icon-checked-circle-green .cls-2{fill:none;stroke:#00b271;stroke-width:1.4px;}#icon-icon-checked-circle-green .cls-1{stroke-miterlimit:10;}#icon-icon-checked-circle-green .cls-2{stroke-linecap:round;stroke-linejoin:round;}</style></defs><title>资源 1</title><g id=\"icon-icon-checked-circle-green_图层_2\" data-name=\"图层 2\"><g id=\"icon-icon-checked-circle-green_图层_1-2\" data-name=\"图层 1\"><circle class=\"cls-1\" cx=\"7.7\" cy=\"7.7\" r=\"7\" /><polyline class=\"cls-2\" points=\"4.3 7.2 7 9.9 11.2 5.7\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-checked-circle-green.svg
// module id = qh5Z
// module chunks = 75